import { createRouter, createWebHashHistory } from "vue-router";
import Home from "@/views/home/index.vue";
import Index from "@/views/index/index.vue";
import ResultHome from "@/views/resultHome/index.vue";

import ResultData from "@/views/resultData/index.vue";
import ResultChart from "@/views/resultChart/index.vue";
import SetHome from "@/views/setHome/index.vue";
import userSetIndex from "@/views/userSet/index/index.vue";

import ParamSet from "@/views/paramSet/index.vue";
import DiffSet from "@/views/diffSet/index.vue";
import AutoSet from "@/views/autoSet/index.vue";
import DeviceSet from "@/views/deviceSet/index.vue";

import History from "@/views/history/index.vue";
import SeatSelect from "@/views/seatSelect/index.vue";
import About from "@/views/about/index.vue";
import AboutNew from "@/views/aboutNew/index.vue";
import Shit from "@/views/shit/index.vue";

import setHome from "@/views/setHome2/index.vue";
import adminSetIndex from "@/views/adminSet/index/index.vue";
import adminSetParam from "@/views/adminSet/param/index.vue";
import adminSetDeviceHome from "@/views/adminSet/deviceHome/index.vue";
import adminSetSystemNet from "@/views/adminSet/net/index.vue";
import adminSetSystemHome from "@/views/adminSet/systemHome/index.vue";

import userSetSystemHome from "@/views/userSet/systemHome/index.vue";

import userSetAlarm from "@/views/userSet/alarm/index.vue";
import tiaoZhuan from "@/views/tiaoZhuan/index.vue";

const routes = [
  {
    path: "",
    name: "Home",
    component: Home,
    children: [
      {
        path: "",
        name: "Index",
        component: Index,
      },

      {
        path: "history",
        name: "History",
        component: History,
      },
      {
        path: "shit",
        name: "Shit",
        component: Shit,
      },
      {
        path: "seatSelect/:historyId",
        name: "SeatSelect",
        component: SeatSelect,
      },
      {
        path: "result/:diskId/:seatId/:historyId",
        name: "ResultHome",
        component: ResultHome,
        children: [
          {
            path: "data",
            name: "ResultData",
            component: ResultData,
          },
          {
            path: "chart",
            name: "ResultChart",
            component: ResultChart,
          },
        ],
      },
      {
        path: "set",
        name: "SetHome",
        component: SetHome,
        children: [
          {
            path: "about",
            name: "AboutNew",
            component: AboutNew,
            meta: { showTxt: "系统设置" },
          },
          {
            path: "auto",
            name: "AutoSet",
            component: AutoSet,
            meta: { showTxt: "班次设置" },
          },
        ],
      },
      {
        path: "userSet",
        name: "userSet",
        component: setHome,
        children: [
          {
            path: "index",
            name: "userSetIndex",
            component: userSetIndex,
            meta: { showTxt: "设置" },
          },
          {
            path: "about",
            name: "AboutNew",
            component: AboutNew,
            meta: { showTxt: "系统设置" },
          },
          {
            path: "auto",
            name: "userAutoSet",
            component: AutoSet,
            meta: { showTxt: "班次设置" },
          },
          {
            path: "param",
            name: "userSetParam",
            component: adminSetParam,
            meta: { showTxt: "参数设置" },
          },
          {
            path: "system",
            name: "userSetSystemHome",
            component: userSetSystemHome,
            meta: { showTxt: "系统设置" },
          },
        ],
      },
      {
        path: "adminSet",
        name: "adminSet",
        component: setHome,
        children: [
          {
            path: "index",
            name: "adminSetIndex",
            component: adminSetIndex,
            meta: { showTxt: "开发者模式" },
          },
          {
            path: "param",
            name: "adminSetParam",
            component: adminSetParam,
            meta: { showTxt: "参数设置" },
          },
          {
            path: "device",
            name: "adminSetDeviceHome",
            component: adminSetDeviceHome,
            meta: { showTxt: "设备管理" },
          },
          {
            path: "alarm",
            name: "userSetAlarm",
            component: userSetAlarm,
            meta: { showTxt: "报警设置" },
          },
          {
            path: "param",
            name: "ParamSet",
            component: ParamSet,
            meta: { showTxt: "脉动参数设置" },
          },
          {
            path: "diff",
            name: "DiffSet",
            component: DiffSet,
            meta: { showTxt: "数据校准" },
          },

          {
            path: "deviceSet",
            name: "DeviceSet",
            component: DeviceSet,
            meta: { showTxt: "设备管理" },
          },
          {
            path: "auto",
            name: "adminAutoSet",
            component: AutoSet,
            meta: { showTxt: "班次设置" },
          },

          {
            path: "system",
            name: "adminSetSystemHome",
            component: adminSetSystemHome,
            meta: { showTxt: "系统设置" },
          },
        ],
      },
      // {
      //   path: "system",
      //   name: "adminSetSystemHome",
      //   component: adminSetSystemHome,
      //   children: [
      //     {
      //       path: "about",
      //       name: "adminSetSystemAbout",
      //       component: AboutNew,
      //     },
      //     {
      //       path: "net",
      //       name: "adminSetSystemNet",
      //       component: adminSetSystemNet,
      //     },
      //   ],
      // },
      {
        path: "tiaoZhuan",
        name: "tiaoZhuan",
        component: tiaoZhuan,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
